"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maskPatternFromMessage = maskPatternFromMessage;
exports.validateMessage = validateMessage;
var _creditCardType = _interopRequireDefault(require("credit-card-type"));
var _dataProtectionHelper = require("../helper/data-protection-helper");
var _dataProtectionErrors = _interopRequireDefault(require("../error-messages/data-protection-errors"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
 * Copyright 2018 Expedia, Inc. All rights reserved.
 * EXPEDIA PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

/*
 * Validate and mask the message content for credit card compliance.
 */

function maskPatternFromMessage(message, patternToMask) {
  if (!message || typeof message !== 'string') {
    throw new Error(_dataProtectionErrors["default"].INVALID_MESSAGE);
  }
  if (!patternToMask || typeof patternToMask !== 'string') {
    throw new Error(_dataProtectionErrors["default"].INVALID_MASK_PATTERN);
  }
  var regex = new RegExp(patternToMask, 'g');
  return message.replace(regex, '****');
}

// File used to have multiple non-default exports, avoiding changing public contract.
// eslint-disable-next-line import/prefer-default-export
function validateMessage(message) {
  if (!message || typeof message !== 'string') {
    throw new Error(_dataProtectionErrors["default"].INVALID_MESSAGE);
  }
  var maskedMessage = message;
  var cardMatches = (0, _dataProtectionHelper.getCardMatches)(message);
  var ssnMatches = (0, _dataProtectionHelper.getSsnMatches)(message);
  if (cardMatches) {
    cardMatches.forEach(function (matchSet) {
      matchSet.every(function (cardString) {
        var cards = (0, _creditCardType["default"])(cardString);
        var isPossibleCard = cards.length > 0;
        var isValidCardString = isPossibleCard && (0, _dataProtectionHelper.checkLuhn)(cardString);
        if (isValidCardString) {
          var completeMaskedCardString = (0, _dataProtectionHelper.getMaskedCardString)(cardString);
          maskedMessage = maskedMessage.replace(cardString, completeMaskedCardString);
          return false;
        }
        return true;
      });
    });
  }
  if (ssnMatches) {
    ssnMatches.forEach(function (matchSet) {
      matchSet.every(function (ssnString) {
        if (ssnString) {
          var completeMaskedSsnString = (0, _dataProtectionHelper.getMaskedSsnString)(ssnString);
          maskedMessage = maskedMessage.replace(ssnString, completeMaskedSsnString);
          return false;
        }
        return true;
      });
    });
  }
  return maskedMessage;
}